<template>
  <section class="inv">
    <div class="inv__head">
      <span class="inv__label">Pagos y comprobantes</span>
      <button v-if="invoices.length" class="inv__link" :disabled="busy" @click="$emit('download', null)">Descargar todos</button>
    </div>

    <table v-if="invoices.length" class="inv__table">
      <thead>
        <tr><th>Fecha</th><th>Periodo</th><th>Plan</th><th>Monto</th><th class="inv__actions-h"></th></tr>
      </thead>
      <tbody>
        <tr v-for="i in invoices" :key="i.id">
          <td class="gray">{{ formatShortDate(i.issuedAt) }}</td>
          <td class="navy">{{ i.period }}</td>
          <td><span class="tag">{{ i.planName }}</span></td>
          <td class="amt"><span class="mono">${{ formatMoney(i.amount, true) }}</span><span class="st st--green">Pagada</span></td>
          <td class="inv__actions">
            <button class="ico" title="Descargar PDF" aria-label="Descargar comprobante" :disabled="busy" @click="$emit('download', i)"><span class="mdi mdi-download-outline"></span></button>
            <button class="ico" title="Vista previa" aria-label="Ver comprobante" @click="$emit('preview', i)"><span class="mdi mdi-eye-outline"></span></button>
          </td>
        </tr>
      </tbody>
    </table>
    <div v-else class="inv__empty">Los comprobantes aparecerán aquí una vez que tu suscripción esté activa</div>
  </section>
</template>

<script setup>
import { formatShortDate, formatMoney } from './planFormat'
defineProps({ invoices: { type: Array, required: true }, busy: Boolean })
defineEmits(['download', 'preview'])
</script>

<style scoped>
.inv { padding: 16px 18px; background: #fff; border: 1px solid #e2e8f0; border-radius: 8px; box-sizing: border-box; }
.inv__head { display: flex; justify-content: space-between; align-items: center; margin-bottom: 8px; }
.inv__label { font: 500 12px var(--font-body); color: #64748b; text-transform: uppercase; letter-spacing: 0.04em; }
.inv__link { background: none; border: none; padding: 0; cursor: pointer; font: 400 11px var(--font-body); color: #3b82f6; }
.inv__link:disabled { opacity: 0.5; cursor: default; }
.inv__table { width: 100%; border-collapse: collapse; }
.inv__table th { text-align: left; padding: 6px 8px; font: 500 10px var(--font-body); color: #94a3b8; text-transform: uppercase; letter-spacing: 0.04em; border-bottom: 1px solid #f1f5f9; }
.inv__table td { padding: 11px 8px; border-bottom: 1px solid #f1f5f9; vertical-align: middle; }
.inv__table tr:last-child td { border-bottom: none; }
.gray { font: 400 12px var(--font-body); color: #64748b; white-space: nowrap; }
.navy { font: 400 12px var(--font-body); color: #1e3a5f; }
.tag { padding: 2px 8px; background: #f1f5f9; border-radius: 4px; font: 400 10px var(--font-body); color: #64748b; }
.amt { white-space: nowrap; }
.mono { font: 400 12px var(--font-mono); color: #1e3a5f; margin-right: 8px; }
.st { padding: 2px 8px; border-radius: 10px; font: 500 10px var(--font-body); }
.st--green { background: #dcfce7; color: #166534; }
.inv__actions { text-align: right; white-space: nowrap; }
.ico { background: none; border: none; cursor: pointer; padding: 4px 5px; font-size: 14px; color: #94a3b8; border-radius: 4px; }
.ico:hover:not(:disabled) { color: #3b82f6; background: #eff6ff; }
.ico:disabled { opacity: 0.5; cursor: default; }
.inv__empty { padding: 26px 8px; text-align: center; font: 400 12px var(--font-body); color: #94a3b8; }
@media (max-width: 640px) { .inv__table { display: block; overflow-x: auto; } }
</style>